export default "__VITE_ASSET__DyU3$3B2__"